import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, isRef as _isRef, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/loading.gif'
import _imports_1 from '@/assets/tip.png'
import _imports_2 from '@/assets/notice-bj.png'


const _withScopeId = n => (_pushScopeId("data-v-15792af0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "calling" }
const _hoisted_2 = {
  key: 0,
  class: "calling-await"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "phone-tip" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("span", null, "接通中...")
], -1))
const _hoisted_4 = { class: "phone-warp" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "phone-warp-tip" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createElementVNode("span", null, "温馨提示:视频期间请勿退出或切换此页面至后台")
], -1))
const _hoisted_6 = {
  key: 0,
  class: "phone-warp-text"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 请耐心等待 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 医生繁忙，请稍作等待 ")
const _hoisted_10 = {
  key: 1,
  class: "phone-warp-text"
}
const _hoisted_11 = { class: "question" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "phone-warp-tip" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createElementVNode("span", null, "温馨提示:视频期间请勿退出或切换此页面至后台")
], -1))
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "overlay-wrapper-img",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hea-justifyC" }, "是否确认挂断", -1))
const _hoisted_17 = { class: "overlay-btn btn-list" }
const _hoisted_18 = {
  key: 1,
  class: "questionnaire-info"
}
const _hoisted_19 = { class: "questionnaire-info-warp" }
const _hoisted_20 = { class: "questionnaire-info-btn" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "overlay-wrapper-img",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hea-justifyC" }, "请认真核实问卷结果，核对无误后请点击确认进入下一步", -1))
const _hoisted_23 = { class: "overlay-btn btn-list" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "overlay-wrapper-img",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hea-justifyC" }, "签名不匹配，与投保单不一致，请您重新填写", -1))
const _hoisted_26 = {
  key: 3,
  class: "sign-pdf hea-justifyC"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sign-pdf-txt" }, "正在核实签名,请不要退出", -1))
const _hoisted_28 = { class: "sign-pdf-warp" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "overlay-wrapper-img",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hea-justifyC" }, "未检测到授权的摄像头和麦克风，请退出系统后重新登录并授权", -1))
const _hoisted_31 = { class: "btn-list overlay-btn" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "overlay-wrapper-img",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hea-justifyC" }, "医生重连成功，请继续完成视频问卷", -1))
const _hoisted_34 = { class: "btn-list overlay-btn" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "overlay-wrapper-img",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_36 = {
  class: "hea-justifyC",
  style: {"margin-bottom":"8px","font-size":"20px"}
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hea-justifyC" }, "医生连接异常，紧急修复中，请耐心等待医生重连", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "overlay-wrapper-img",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hea-justifyC" }, "非常抱歉，医生重连失败，是否继续等待", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "overlay-wrapper-img",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hea-justifyC" }, "非常抱歉，医生重连失败，请稍后重新发起问卷", -1))
const _hoisted_42 = { class: "btn-list overlay-btn" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "overlay-wrapper-img",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "已与医生连接成功，请点击“开始问卷”", -1))

import { computed, onMounted, reactive, ref, inject, nextTick, onUnmounted, getCurrentInstance } from "vue";
import tabbar from "src/components/common/tabbar";
import dayjs from "dayjs";
import { TRTCService, QuestionnaireService, AuthService } from "src/services";
import { Toast } from "vant";
import TRTCCalling from "trtc-calling-js";
import { useTRTCStore, useUserInfo } from "src/store";
import { useRouter, useRoute } from "vue-router";
import XhyAutograph from "src/components/common/autograph";
import pdfPreview from "src/components/common/pdf-preview";
import globalConfig from "../config";
import * as SignalR from "@microsoft/signalr";
import TRTC from "trtc-js-sdk";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { proxy }: any = getCurrentInstance();
// const { initSocket, socket } = useTRTCStore();
const { getUserInfo } = useUserInfo();
let $autograph = ref(null);
let router = useRouter();
let route = useRoute();
let state = reactive({
  answerHtml: null, // html
  result: false, // 是否请求医生状态结果
  isDoctorBusy: false, // 是否繁忙
  connectDoctorModal: false, // 医生成功接听
  reconnectionTimer: null, // 重连到计时定时器
  reconnectionTime: null, // 重连到计时
  doctorReconnectionSuccess: false, // 医生重连成功
  doctorReconnectionFail: false, // 医生重连失败
  doctorReconnection: false, // 医生端重连
  doctorReconnectionFailAwait: false, // 重连失败继续等待

  doctorReconnectionFailTimer: null, // 重连失败继续等待计时定时器
  doctorReconnectionFailTime: null, // 重连失败继续等待到计时

  doctorException: false, // 医生是否退出房间
  doctorExceptionNum: 0, // 等待医生到计时次数
  localStream: null, // 本地流
  remoteStream: null, // 远程流
  TRTCClient: null,
  showPermission: false,
  showResetSignOverlay: false, // 重新签名时弹框
  waitingNum: 0, // 等待人数
  socket: null,
  answerBase64: null,
  pdfUrl: "",
  userSig: "",
  localVideo: true,
  showQuestion: true,
  isVideoOn: false,
  signPDFUrl: "",
  showSignPDF: false,
  showChangeOverlay: false, // 超时弹框
  questionnaireList: [],
  title: "",
  answer: null,
  pdfBase64: "",
  currntIndex: 1, // 当前题号
  showQuestionnaireModal: false,
  showAutographOverlay: false,
  showAutograph: false,
  showAutographConfirmOverlay: false, // 确认签名弹框
  showCallErrOverlay: false, // 呼叫医生失败弹框
  showCallErrText: "", // 呼叫医生失败文字
  taskId: "", // 任务id
  doctorId: "", // 医生id
  roomIdStr: "",
  autographOptions: {
    penColor: "black", //笔刷颜色
    minWidth: 2, //最小宽度
  },
  questionVersion: "",
});

// 添加日志
let addTrtcLog = async (content) => {
  await TRTCService.instance.addTrtcLog({
    roomId: state.roomIdStr,
    logContent: content,
    logsource: 1,
  });
};

// 签字并
let onAutographOverlay = async (content) => {
  document
    .getElementById("view")
    .setAttribute("content", "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0");
  state.showAutographOverlay = true;
};

// 当前登录用户信息
let userInfo = computed(() => {
  return getUserInfo();
});

// 确认签名
let onConfirmAutograph = () => {
  state.socket.send("ClientConfirmAnswer", {
    taskId: state.taskId + "",
    doctorId: state.doctorId + "",
    answers: state.answer,
    answerBase64: state.answerBase64,
    questionVersion: state.questionVersion,
  });

  state.showAutographOverlay = false;
  state.showAutograph = true;
};

/**
 * base64转Blob
 */
const base64ToBlob = (code: string): Blob => {
  //Base64一行不能超过76字符，超过则添加回车换行符。因此需要把base64字段中的换行符，回车符给去掉，有时候因为存在需要把加号空格之类的换回来，取决于base64存取时的规则。
  code = code.replace(/[\n\r]/g, "");
  var raw = window.atob(code);
  let rawLength = raw.length;
  //转换成pdf.js能直接解析的Uint8Array类型
  let uInt8Array = new Uint8Array(rawLength);
  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }
  return new Blob([uInt8Array], { type: "application/pdf" }); //转成pdf类型
};

// 获取当前问卷信息
let questionnaire = computed(() => {
  if (state.questionnaireList && state.questionnaireList.length > 0) {
    return `${state.currntIndex}/${state.questionnaireList.length} ${
      state.questionnaireList && state.questionnaireList[state.currntIndex - 1].question
    }`;
  }
});

/**
 * 切换视频
 *
 */
let onSwitchVideo = (bol) => {
  if (state.localVideo == bol) {
    state.localVideo = !state.localVideo;
  }
};

/**
 * 刷新时长
 *
 */
let refreshAuth = async () => {
  try {
    await AuthService.instance.refreshAuth();
  } catch (err) {
    console.log(err);
    Toast(err);
  }
};

/**
 * 重连失败断开
 *
 */
let onAwaitOff = async () => {
  router.push({ name: "home" });
};

/**
 * 未授权关闭回首页
 *
 */
let onUnPermission = () => {
  let ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    wx.closeWindow();
  } else {
    window.close();
  }
  // state.showPermission = false;
  // router.push({name: "home"});
};

// 医生断开
let onReceiveDoctorException = async () => {};

// 确定签名
const receiveQmValue = (val) => {
  let base64 = val.replace("data:image/png;base64,", "");
  // 签名
  state.socket.send("ClientSign", {
    taskId: state.taskId + "",
    roomIdStr: state.roomIdStr,
    doctorId: state.doctorId + "",
    answers: state.answer,
    signBase64: base64,
    answerHtml: state.answerHtml,
    questionVersion: state.questionVersion,
  });

  // state.showAutographConfirmOverlay = true;
  // state.showQuestionnaireModal = false;
};

// 客户确认签字
const onAutographConfirm = (val) => {
  document
    .getElementById("view")
    .setAttribute("content", "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0");
  state.showSignPDF = true;
  state.showAutograph = false;
  state.showAutographConfirmOverlay = false;
};

/**
 * 获取问卷详情
 * @protected
 * @returns Promise<void>
 */
const getQuestionnaireList = async (taskId: any): Promise<void> => {
  try {
    let { content: result } = await QuestionnaireService.instance.getQuestionnaireList(taskId);
    if (result.data) {
      state.questionnaireList = (result.data && result.data.questions) || [];
      state.title = (result.data && result.data.title) || [];
      state.questionVersion = result.data?.version || "";
    }
  } catch (err) {
    console.log(err);
    Toast(err);
  }
};

/**
 * 问卷任务
 * @protected
 * @returns Promise<void>
 */
const questionnaireTaskCalling = async (id): Promise<void> => {
  try {
    let { content: result } = await QuestionnaireService.instance.questionnaireTaskCalling(id);
    // 初始化本地流
    handlerLocalStream();
  } catch (err) {
    Toast(err);
    router.push({ name: "home" });
  }
};

/**
 * 获取TRTC签名
 *
 */
let getUserSig = async () => {
  try {
    let { content: res } = await TRTCService.instance.getUserSig();
    if (res.data) {
      state.userSig = res.data;
      initTRTCClient();
      if (state.roomIdStr) {
        state.TRTCClient.join({ roomId: state.roomIdStr })
          .then(() => {
            // 处理本地流
            publishLocalStream();
          })
          .catch((error) => {
            console.log("Join room failed: " + error);
          });
      }
    }
  } catch (err) {
    console.log(err);
    Toast(err);
  }
};

/**
 * 取消拨打电话
 *
 */
let onCancelCall = () => {
  state.socket.send("ClientSendRingOff", userInfo.value.userId + "", route.query.id + "");
  router.push({ name: "home" });
};

onMounted(async () => {
  // 设置任务id
  let id = route.query.id as string;
  state.taskId = id;
  initSocket();
  window.addEventListener("beforeunload", (e) => leavePage());
});

const leavePage = async () => {
  // 1:客户端，2:医生端
  if (state.roomIdStr) {
    let bol = state.doctorException ? true : false;
    await state.socket.send("Leave", state.roomIdStr, 1, bol);
    console.log("成功返回页面");
  } else {
    await state.socket.send("ClientSendRingOff", userInfo.value.userId + "", state.taskId + "");
  }

  if (state.localStream) {
    await state.localStream.stop();
    await state.localStream.close();
  }
  onOffSocketListener();
  if (state.TRTCClient) {
    await state.TRTCClient.leave();
    await state.TRTCClient.destroy();
    state.TRTCClient = null;
  }

  if (state.socket) {
    await state.socket.stop();
  }
};

onUnmounted(async () => {
  leavePage();
  window.removeEventListener("beforeunload", (e) => leavePage());
});

// 医生端离开
const doctorLeave = () => {
  if (state.roomIdStr) {
    // 1:客户端，2:医生端
    state.socket.send("Leave", state.roomIdStr, 2, false);
  }

  state.doctorExceptionNum++;
  state.doctorException = true;
  state.reconnectionTime = 60;
  state.doctorReconnection = true;
  // 网络异常，紧急修复中到计时
  state.reconnectionTimer = setInterval(() => {
    state.reconnectionTime--;
    if (state.reconnectionTime <= 0) {
      clearInterval(state.reconnectionTimer);
      state.doctorReconnectionFailAwait = true;
      state.doctorReconnectionFailTime = 60;
      // 非常抱歉，医生重连失败，是否继续等待到计时
      state.doctorReconnectionFailTimer = setInterval(() => {
        state.doctorReconnectionFailTime--;
        if (state.doctorReconnectionFailTime <= 0) {
          clearInterval(state.doctorReconnectionFailTimer);
          state.doctorReconnectionFail = true;
          state.doctorReconnectionFailAwait = false;
          state.doctorReconnection = false;
        }
      }, 1000);
    }
  }, 1000);
};

// 继续等待医生
const onAwaitDoctor = () => {
  state.reconnectionTime = 60;
  state.doctorReconnection = true;
  state.doctorReconnectionFailAwait = false;
  clearInterval(state.doctorReconnectionFailTimer);
  state.doctorExceptionNum++;
  // 网络异常，紧急修复中到计时
  state.reconnectionTimer = setInterval(() => {
    state.reconnectionTime--;
    if (state.reconnectionTime <= 0) {
      clearInterval(state.reconnectionTimer);

      if (state.doctorExceptionNum >= 3) {
        // 等待3次，直接弹框关闭
        state.doctorReconnectionFail = true;
        state.doctorReconnectionFailAwait = false;
        state.doctorReconnection = false;
      } else {
        state.doctorReconnectionFailAwait = true;
        state.doctorReconnectionFailTime = 60;
        // 非常抱歉，医生重连失败，是否继续等待到计时
        state.doctorReconnectionFailTimer = setInterval(() => {
          state.doctorReconnectionFailTime--;
          if (state.doctorReconnectionFailTime <= 0) {
            clearInterval(state.doctorReconnectionFailTimer);
            state.doctorReconnectionFail = true;
            state.doctorReconnectionFailAwait = false;
            state.doctorReconnection = false;
          }
        }, 1000);
      }
    }
  }, 1000);
};

// 等待医生重连挂断
const onOffDoctor = () => {
  if (state.roomIdStr) {
    // 1:客户端，2:医生端
    state.socket.send("Leave", state.roomIdStr, 1, true);
  }
  state.doctorReconnectionFail = true;
  state.doctorReconnection = false;
  state.doctorReconnectionFailAwait = false;
};

// 继续问卷
const onContinueQuestionnaire = () => {
  state.connectDoctorModal = false;
  state.remoteStream.resume();
};

const initTRTCClient = async () => {
  // 初始化TRTC
  state.TRTCClient = TRTC.createClient({
    mode: "rtc",
    sdkAppId: globalConfig.SDKAppID,
    userId: userInfo.value.userId + "",
    enableAutoPlayDialog: false,
    userSig: state.userSig,
    useStringRoomId: true,
    autoSubscribe: false, // 默认为 true 即自动订阅
  });
  // 订阅远端流首先需要知道有哪些远端流可以订阅，可以通过监听事件 Client.on('stream-added') 获取房间内的远端流，收到该事件说明这个远端流可以进行订阅，在事件回调通过 Client.subscribe() 订阅远端音视频流。
  state.TRTCClient.on("stream-added", (event) => {
    const remoteStream = event.stream;
    addTrtcLog(`远端流增加`);
    console.log("远端流增加: " + remoteStream.getId());
    //订阅远端流
    state.TRTCClient.subscribe(remoteStream);
  });

  // 远端流移除事件，当远端用户取消发布流后会收到该通知。
  state.TRTCClient.on("stream-removed", (event) => {
    // addTrtcLog(`远端流移除事件`);
    console.log("远端流移除事件", event);
  });

  // 远端流更新事件，当远端用户添加、移除或更换音视频轨道后会收到该通知。
  state.TRTCClient.on("stream-updated", (event) => {
    // addTrtcLog(`远端流更新事件:${JSON.stringify(event)}`);
    console.log("远端流更新事件", event);
  });

  // 本地 client 与腾讯云的连接状态变更事件。
  state.TRTCClient.on("connection-state-changed", (event) => {
    addTrtcLog(`本地client与腾讯云的连接状态变更事件:${JSON.stringify(event)}`);
    console.log("本地client与腾讯云的连接状态变更事件", event);
  });

  // 远端用户进房通事件。
  state.TRTCClient.on("peer-join", (event) => {
    console.log("加入房间");
    console.log(state.doctorException);
    // 异常中断重连成功
    if (state.doctorException) {
      addTrtcLog(`医生远端用户异常中断重连进房通事件。:${JSON.stringify(event)}`);
      // state.doctorReconnectionSuccess = true;
      state.doctorException = false;
      state.doctorReconnectionFail = false;
      state.doctorReconnectionFailAwait = false;
      state.doctorReconnection = false;
      if (state.reconnectionTimer) {
        clearInterval(state.reconnectionTimer);
      }
    } else {
      addTrtcLog(`远端用户进房通知事件:${JSON.stringify(event)}`);
    }

    console.log("远端用户进房通知事件。", event);
  });

  // 远端用户退房事件知。
  state.TRTCClient.on("peer-leave", (event) => {
    doctorLeave();

    addTrtcLog(`远端用户退房事件通知。:${JSON.stringify(event)}`);
    console.log("远端用户退房事件知。", event);
  });

  // 远端流禁用音频事件，远端用户禁用音频时会触发该事件。
  state.TRTCClient.on("mute-audio", (event) => {
    addTrtcLog(`远端流禁用音频事件:${JSON.stringify(event)}`);
    console.log("远端流禁用音频事件", event);
  });
  // 远端流禁用视频事件，远端用户禁用视频时会触发该事件。
  state.TRTCClient.on("mute-video", (event) => {
    addTrtcLog(`远端流禁用视频事件:${JSON.stringify(event)}`);
    console.log("远端流禁用视频事件", event);
  });

  // 远端流启用音频事件，远端用户启用音频时会触发该事件。
  state.TRTCClient.on("unmute-audio", (event) => {
    addTrtcLog(`远端流启用音频事件:${JSON.stringify(event)}`);
    console.log("远端流启用音频事件", event);
  });
  // 远端流启用视频事件，远端用户禁用视频时会触发该事件。
  state.TRTCClient.on("mute-video", (event) => {
    addTrtcLog(`远端流启用视频事件:${JSON.stringify(event)}`);
    console.log("远端流启用视频事件", event);
  });

  //         用户被踢出房间事件，被踢原因有：
  // 同名用户进入同一房间，注意：禁止同名用户同时进入同一房间，会导致双方音视频通话异常，业务侧应避免出现这种情况。
  // 被账户管理员使用服务端 API 踢出房间。
  state.TRTCClient.on("client-banned", (event) => {
    addTrtcLog(`用户被踢出房间事件:${JSON.stringify(event)}`);
    console.log("用户被踢出房间事件", event);
  });
  // 网络质量统计数据事件，进房后开始统计，每两秒触发一次，包括上、下行的网络质量数据。
  state.TRTCClient.on("network-quality", (event) => {
    // state.networkQuality = event;
    // console.log(new Date());
    // console.log("网络质量统计数据事件", event);
    // console.log(`network-quality, uplinkNetworkQuality:${event.uplinkNetworkQuality}, downlinkNetworkQuality: ${event.downlinkNetworkQuality}`)
    // console.log(`上传RTT(ms):${event.uplinkRTT} 上传丢包率:${event.uplinkLoss}`)
    // console.log(`下载RTT(ms):${event.downlinkRTT} 下载丢包率:${event.downlinkLoss}`)
  });

  // 错误事件，当出现不可恢复错误后，会抛出此事件
  state.TRTCClient.on("error", (event) => {
    addTrtcLog(`TRTCClient错误:${JSON.stringify(event)}`);
    // 错误码：https://cloud.tencent.com/document/product/647/34342
    console.log("err", event);
  });

  /**
         * 在远端流订阅成功事件回调中，通过调用 Stream.play() 方法在网页中播放音视频。play 方法接受一个 div 元素 ID 或者一个 HTMLDivElement 对象作为参数，SDK 会在该 div 元素下自动创建相应的音视频标签并播放音视频。
            play 方法更详细的参数说明参见 Stream.play()。 
         */
  state.TRTCClient.on("stream-subscribed", (event) => {
    state.remoteStream = event.stream;
    // addTrtcLog(`TRTCClient错误:${JSON.stringify(event)}`);
    console.log("远端流订阅成功：" + state.remoteStream.getId());
    console.log(event);
    state.remoteStream.on("error", (error) => {
      // addTrtcLog(`远端流错误:${JSON.stringify(event)}`);
      const errorCode = error.getCode();
      console.log(`远程流获取失败,errorCode:${errorCode},${error}`);
      if (errorCode === 0x4043) {
        state.connectDoctorModal = true;
        console.log("errorCode === 0x4043");
        // PLAY_NOT_ALLOWED, 引导用户手势操作并调用 stream.resume 恢复音视频播放
        // remoteStream.resume()
      }
    });
    nextTick(() => {
      // 创建播放容器
      let remotePlayerElement = document.createElement("div");
      remotePlayerElement.id = "remote-video";
      document.body.appendChild(remotePlayerElement);
      // 开始播放远端流，传入 play 方法的 Element ID 必须是页面里存在的 div 元素
      state.remoteStream.play(remotePlayerElement.id);
    });
  });
};

let ClientPreCall = async () => {
  console.log("发送预呼叫");
  let id = route.query.id as string;
  await state.socket.send("ClientPreCall", {
    taskId: id + "",
    memberId: userInfo.value.userId + "",
    memberName: userInfo.value.userName,
  });
  console.log("发送预呼叫成功");
};

// 加入房间
const joinRoom = async ({ doctorId, roomIdStr, answerNo }) => {
  state.currntIndex = answerNo;
  state.doctorId = doctorId;
  state.roomIdStr = roomIdStr;
  let id = route.query.id as string;
  // 获取问卷列表
  getQuestionnaireList(id);
  console.log("加入房间");
  // 初始化本地流
  console.log(state.TRTCClient);
  if (state.TRTCClient) {
    await state.TRTCClient.join({ roomId: roomIdStr });
    // 发布本地流
    publishLocalStream();
  } else {
    getUserSig();
  }

  // 显示视频
  state.isVideoOn = true;
};

// https://web.sdk.qcloud.com/trtc/webrtc/doc/zh-cn/LocalStream.html#setVideoProfile
const handlerLocalStream = async () => {
  try {
    state.localStream = TRTC.createStream({ userId: userInfo.value.userId + "", audio: true, video: true });
    state.localStream.setVideoProfile("480p");
    state.localStream.setAudioProfile("high");
    await state.localStream.initialize();
    ClientPreCall();
    console.log("初始化本地流成功");
  } catch (error) {
    state.showPermission = true;
    console.log("初始化本地流失败");
  }
};

const publishLocalStream = async () => {
  // 发布本地流
  try {
    console.log("本地流");
    if (!document.getElementById("local-video").innerHTML) {
      console.log("渲染本地流");
      state.localStream.play("local-video");
    }

    console.log("本地流发布");
    await state.TRTCClient.publish(state.localStream);
    console.log("本地流发布成功");
  } catch (error) {
    console.log("本地流发布失败 " + error);
  }
};

// 接受正在等待的人数
const receiveWaitingNums = (num) => {};

// 接收前面等待人数
const receiveClientWaitingNums = async () => {
  try {
    let { content: res } = await TRTCService.instance.getUserQueueNum(userInfo.value.userId + "");
    state.isDoctorBusy = res.data.isDoctorBusy;
    state.result = true;
    if (!res.data.isDoctorBusy) {
      state.waitingNum = res.data.currentQueue || 0;
    }
  } catch (err) {
    console.log(err);
    Toast(err);
  }
};

// 结束视频问卷
function onCompletedQuestion(id) {
  router.push({ name: "questionnaireSuccess", query: { id: id } });
}

// 接受显示的题号
function receiveTurnQuestionPages(pageNum) {
  state.currntIndex = pageNum;
  refreshAuth();
}

// 显示问卷pdf base64
function receiveQuestionAnswer(base64, answerHtml, answer) {
  state.showQuestionnaireModal = false;
  state.answerHtml = answerHtml;
  state.pdfUrl = window.URL.createObjectURL(base64ToBlob(base64));
  state.answer = answer;
  state.answerBase64 = base64;
  setTimeout(() => {
    state.showQuestionnaireModal = true;
  }, 100);
  state.showQuestion = false;
}

// 接受签名后的PDf
function receiveMemberSign(answerBase64, signBase) {
  // 接受签名后的PDf
  state.signPDFUrl = window.URL.createObjectURL(base64ToBlob(answerBase64));
  document
    .getElementById("view")
    .setAttribute("content", "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0");
  state.showSignPDF = true;
  state.showAutograph = false;
  state.showAutographConfirmOverlay = false;
  state.showQuestionnaireModal = false;
}

// 客户端重连 todo
function onClientReconnect(data) {
  console.log("客户端重连");
  joinRoom(data);
}

// 确认签名
function onConfirmResetSignOverlay() {
  $autograph.value && $autograph.value.againFull();
  state.showAutograph = true;
  state.showSignPDF = false;
  state.showResetSignOverlay = false;
}

// 重新签名
function reSign() {
  state.showResetSignOverlay = true;
  state.showAutographConfirmOverlay = false;
}

// 初始化Socket
const initSocket = async () => {
  let token = JSON.parse(localStorage.getItem("token")).accessToken;
  state.socket = new SignalR.HubConnectionBuilder()
    .configureLogging(SignalR.LogLevel.Information)
    .withAutomaticReconnect()
    .withUrl(globalConfig.signalrUrl, {
      accessTokenFactory: () => token,
      skipNegotiation: false,
      transport: SignalR.HttpTransportType.WebSockets,
    })
    .build();

  state.socket.serverTimeoutInMilliseconds = 60 * 1000;
  await state.socket.start();
  initSocketListener();
  // 增加呼叫记录
  questionnaireTaskCalling(state.taskId);
  // 拿到TRTC签名并登入
  getUserSig();
};

// 初始化监听事件
function initSocketListener() {
  // 加入房间
  state.socket.on("JoinRoom", joinRoom);
  // 接受等待人数
  state.socket.on("ReceiveWaitingNums", receiveWaitingNums);
  // 接受客户端等待人数
  state.socket.on("ReceiveClientWaitingNums", receiveClientWaitingNums);
  // 接受问卷题目
  state.socket.on("ReceiveTurnQuestionPages", receiveTurnQuestionPages);
  // 医生接受问卷pdf base64
  state.socket.on("ReceiveQuestionAnswer", receiveQuestionAnswer);
  // 接受签名后的PDf
  state.socket.on("ReceiveMemberSign", receiveMemberSign);
  // 重新签名
  state.socket.on("ReSign", reSign);
  // 完成问卷
  state.socket.on("CompletedQuestion", onCompletedQuestion);
  // 客户端重连
  state.socket.on("ClientReconnect", onClientReconnect);
}

// 移除监听事件
function onOffSocketListener() {
  // 加入房间
  state.socket.off("JoinRoom", joinRoom);
  // 接受等待人数
  state.socket.off("ReceiveWaitingNums", receiveWaitingNums);
  // 接受客户端等待人数
  state.socket.off("ReceiveClientWaitingNums", receiveClientWaitingNums);
  // 接受问卷题目
  state.socket.off("ReceiveTurnQuestionPages", receiveTurnQuestionPages);
  // 医生接受问卷pdf base64
  state.socket.off("ReceiveQuestionAnswer", receiveQuestionAnswer);
  // 接受签名后的PDf
  state.socket.off("ReceiveMemberSign", receiveMemberSign);
  // 重新签名
  state.socket.off("ReSign", reSign);
  // 完成问卷
  state.socket.off("CompletedQuestion", onCompletedQuestion);
  // 客户端重连
  state.socket.off("ClientReconnect", onClientReconnect);
}

return (_ctx: any,_cache: any) => {
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_overlay = _resolveComponent("van-overlay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(state).isVideoOn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            (_unref(state).result)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (!_unref(state).isDoctorBusy)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" 医生正在问询中，当前排队人数:" + _toDisplayString(_unref(state).waitingNum || 1) + "人", 1),
                        _hoisted_7,
                        _hoisted_8
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_9
                      ], 64))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_van_loading, { type: "spinner" })
                ])),
            _createElementVNode("button", {
              class: "btn-primary phone-warp-btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(state).showChangeOverlay = true))
            }, "挂断")
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", {
      id: "local-video",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(onSwitchVideo)(true))),
      class: _normalizeClass({ local: _unref(state).localVideo, remote: !_unref(state).localVideo, showSignPDF: _unref(state).showSignPDF })
    }, null, 2), [
      [_vShow, _unref(state).isVideoOn]
    ]),
    _withDirectives(_createElementVNode("div", {
      id: "remote-video",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(onSwitchVideo)(false))),
      class: _normalizeClass({ local: !_unref(state).localVideo, remote: _unref(state).localVideo, showSignPDF: _unref(state).showSignPDF })
    }, null, 2), [
      [_vShow, _unref(state).isVideoOn]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      (_unref(state).currntIndex == 1)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_13, _toDisplayString(_unref(state).title), 1))
        : _createCommentVNode("", true),
      _createElementVNode("p", { innerHTML: _unref(questionnaire) }, null, 8, _hoisted_14)
    ], 512), [
      [_vShow, _unref(state).isVideoOn && _unref(state).showQuestion]
    ]),
    _createVNode(_component_van_overlay, {
      class: "notice-overlay",
      show: _unref(state).showChangeOverlay,
      onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(state).showChangeOverlay = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "overlay-wrapper",
          onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
        }, [
          _hoisted_15,
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("button", {
              class: "btn-cancel van-hairline--surround",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(state).showChangeOverlay = false))
            }, "取消"),
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(onCancelCall) && _unref(onCancelCall)(...args)))
            }, "确认")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    (_unref(state).showQuestionnaireModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_unref(pdfPreview), {
              url: _unref(state).pdfUrl
            }, null, 8, ["url"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_unref(onAutographOverlay) && _unref(onAutographOverlay)(...args)))
            }, "确认并签名")
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_overlay, {
      class: "notice-overlay",
      show: _unref(state).showAutographOverlay,
      onClick: _cache[10] || (_cache[10] = ($event: any) => (_unref(state).showAutographOverlay = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "overlay-wrapper",
          onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
        }, [
          _hoisted_21,
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_unref(onConfirmAutograph) && _unref(onConfirmAutograph)(...args)))
            }, "确认")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_overlay, {
      class: "notice-overlay",
      show: _unref(state).showResetSignOverlay,
      onClick: _cache[12] || (_cache[12] = ($event: any) => (_unref(state).showResetSignOverlay = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "overlay-wrapper",
          onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
        }, [
          _hoisted_24,
          _hoisted_25,
          _createElementVNode("div", { class: "overlay-btn btn-list" }, [
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: onConfirmResetSignOverlay
            }, "确认")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    (_unref(state).showAutograph)
      ? (_openBlock(), _createBlock(_unref(XhyAutograph), {
          key: 2,
          ref: (_value, _refs) => {
            _refs['$autograph'] = _value
            _isRef($autograph) ? $autograph.value = _value : $autograph = _value
          },
          config: _unref(state).autographOptions,
          onReceive: receiveQmValue
        }, null, 8, ["config"]))
      : _createCommentVNode("", true),
    (_unref(state).showSignPDF)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_unref(pdfPreview), {
              url: _unref(state).signPDFUrl
            }, null, 8, ["url"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_overlay, {
      show: _unref(state).showPermission,
      class: "notice-overlay",
      onClick: _cache[15] || (_cache[15] = ($event: any) => (_unref(state).showPermission = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "overlay-wrapper",
          onClick: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["stop"]))
        }, [
          _hoisted_29,
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_unref(onUnPermission) && _unref(onUnPermission)(...args)))
            }, "确定")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_overlay, {
      show: _unref(state).doctorReconnectionSuccess,
      class: "notice-overlay",
      onClick: _cache[18] || (_cache[18] = ($event: any) => (_unref(state).doctorReconnectionSuccess = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "overlay-wrapper",
          onClick: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"]))
        }, [
          _hoisted_32,
          _hoisted_33,
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: _cache[16] || (_cache[16] = ($event: any) => (_unref(state).doctorReconnectionSuccess = false))
            }, "确定")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_overlay, {
      show: _unref(state).doctorReconnection,
      class: "notice-overlay"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "overlay-wrapper",
          onClick: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["stop"]))
        }, [
          _hoisted_35,
          _createElementVNode("p", _hoisted_36, _toDisplayString(_unref(state).reconnectionTime) + "s", 1),
          _hoisted_37,
          _createElementVNode("div", { class: "btn-list overlay-btn" }, [
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: onOffDoctor
            }, "挂断")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_overlay, {
      show: _unref(state).doctorReconnectionFailAwait,
      class: "notice-overlay"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "overlay-wrapper",
          onClick: _cache[20] || (_cache[20] = _withModifiers(() => {}, ["stop"]))
        }, [
          _hoisted_38,
          _hoisted_39,
          _createElementVNode("div", { class: "btn-list overlay-btn" }, [
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: onOffDoctor
            }, "挂断"),
            _createElementVNode("button", {
              class: "btn-cancel van-hairline--surround",
              onClick: onAwaitDoctor
            }, "继续等待")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_overlay, {
      show: _unref(state).doctorReconnectionFail,
      class: "notice-overlay"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "overlay-wrapper",
          onClick: _cache[22] || (_cache[22] = _withModifiers(() => {}, ["stop"]))
        }, [
          _hoisted_40,
          _hoisted_41,
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_unref(onAwaitOff) && _unref(onAwaitOff)(...args)))
            }, "确认")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_overlay, {
      show: _unref(state).connectDoctorModal,
      class: "notice-overlay",
      onClick: _cache[24] || (_cache[24] = ($event: any) => (_unref(state).connectDoctorModal = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "overlay-wrapper",
          onClick: _cache[23] || (_cache[23] = _withModifiers(() => {}, ["stop"]))
        }, [
          _hoisted_43,
          _hoisted_44,
          _createElementVNode("div", { class: "btn-list overlay-btn" }, [
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: onContinueQuestionnaire
            }, "开始问卷")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})